import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAnalytics } from '../interface/analytics.interface';
import { TrackerData } from '../model/tracker-data.model';
import { UserData } from '../model/user-data.model';

declare let gtag: Function;
const TK_CD_UNKNOWN = 'TK_CD_UNKNOWN';

@Injectable({
  providedIn: 'root'
})

export class AnalyticsService implements IAnalytics {
  private user: UserData;

  constructor() { }

  setUserData(user: UserData) {
    this.user = user;
  }

  sendEvent(data: TrackerData): void {
    const isUnknownUser = !this.user;
    this.internalSendEvent(data, isUnknownUser);
  }

  private getEventParams(data: TrackerData, isUnknownUser: boolean): Record<string, string> {
    const tenant = location.hostname.split('.')[0];
    return {
      page_title: data.analyticType,
      signer_user_id: isUnknownUser ? TK_CD_UNKNOWN : `${this.user.id}`,
      signer_user_name: isUnknownUser ? TK_CD_UNKNOWN : this.user.name,
      signer_user_type: isUnknownUser ? TK_CD_UNKNOWN : `${this.user.type ?? TK_CD_UNKNOWN}`,
      tenant
    };
  }

  private internalSendEvent(data: TrackerData, isUnknownUser: boolean): void {
    if (!environment.googleAnalytics.enabled) {
      return;
    }

    const params = this.getEventParams(data, isUnknownUser);
    const eventName = data.action || 'interaction';
    gtag('event', eventName, {
      event_category: data.analyticType,
      event_label: data.label || '',
      ...params
    });
  }
}
